import { Component, computed, effect, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { distinctUntilChanged } from 'rxjs';
import { RECORD_MANAGER } from '../../../core/services/record.provide';
import { LvrHeading } from '../../../core/components/heading/heading';
import { SponsorDetailsView } from './sponsor-details-view/sponsor-details-view';

@Component({
	selector: 'lvr-sponsor-details',
	standalone: true,
	templateUrl: './sponsor-details.html',
	imports: [TranslocoPipe, LvrHeading, SponsorDetailsView],
})
export class SponsorDetails {
	private readonly recordManager = inject(RECORD_MANAGER);
	private readonly route = inject(ActivatedRoute);
	private readonly data = toSignal(this.route.data.pipe(distinctUntilChanged()));
	private title = signal<string>('');

	public readonly sponsor = computed(() => this.data()?.['sponsor']);

	public constructor() {
		effect(() => {
			const sponsor = this.sponsor();
			if (!sponsor?.name) {
				return;
			}
			if (sponsor.name !== this.title()) {
				this.title.set(sponsor.name);
				this.recordManager.updateRecordTitleOfActiveRecord(this.title());
			}
		});
	}
}
